import { BaseRequest } from '@/network/requests/BaseRequest';
import { jt_command } from '@/interfaces/jt_command';

export const jtCommandRequest = BaseRequest.build<jt_command>('jt_command');